import type { ClinicRoom } from "../api/clinicalWorkspace";
import { TodayActionMenu } from "./TodayActionMenu";

/** A room choice stays beside its patient and always uses the latest room version. */
export function TodayRoomPicker({
  patientName,
  rooms,
  label = "Assign room",
  disabled,
  onAssign,
}: {
  patientName: string;
  rooms: readonly ClinicRoom[];
  label?: string;
  disabled: boolean;
  onAssign: (room: ClinicRoom) => Promise<boolean>;
}) {
  const available = rooms
    .filter((room) => room.state === "available")
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
  return (
    <TodayActionMenu
      className="tb-room-picker"
      label={label}
      disabled={disabled}
      menuLabel={`Available rooms for ${patientName}`}
    >
      {(menu) =>
        available.length ? (
          available.map((room) => (
            <button
              key={room.id}
              type="button"
              role="menuitem"
              disabled={disabled}
              onClick={() =>
                void onAssign(room).then((saved) => {
                  if (saved) menu.close(true);
                  else menu.focus();
                })
              }
            >
              <strong>{room.name}</strong> <span>{room.zone}</span>
            </button>
          ))
        ) : (
          <p>No rooms are available. Mark a prepared room clean in Rooms, then try again.</p>
        )
      }
    </TodayActionMenu>
  );
}
